import React, { useEffect, useState } from 'react'
import { bookingPageTab, bookingPageTabIds, waybillFormatPageTab, waybillFormatPageTabIds } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
// import StandardTicketFormatAndLogo from './StandardTicketFormatAndLogo'
// import TicketFormat from './TicketFormat'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import ExpenseHeads from './ExpenseHeads/ExpenseHeads'
import ExpenseSubHeads from './ExpenseSubHeads/ExpenseSubHeads'
import { useTranslation } from '../../../../i18n/I18nProvider'

export const expenseHeadsPageTabWithId = [
  { name: 'Expense Head', translationKey: 'ehExpenseHead', JobID: 47 },
  { name: 'Expense Sub Head', translationKey: 'ehExpenseSubHead', JobID: 48 },
]
const ExpenseHead = () => {
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [selectedTab, setSelectedTab] = useState(47)
  const [allTabs, setAllTabs] = useState([])

  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);
    // if (selectedTab === '' || selectedTab === undefined) {
    //   const newData = standardRateTabs.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null)
    //   goToTabs(newData?.[0]?.JobID, {})
    // }

    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
    } else {
      setAllTabs([])
    }
  }, [selectedTab]);
  const getBookingPageContent = (typeId, label, selectedTab) => {
    switch (typeId) {
      case 47:
        return <ExpenseHeads selectedTab={selectedTab} />
      case 48:
        return <ExpenseSubHeads selectedTab={selectedTab} />

      default:
        return label
    }
  }
  return (
    <>
      <Box className="bookingPageTabContainer">
        <Item>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={selectedTab}
              onChange={(e, newValue) => setSelectedTab(newValue)}
              variant="scrollable"
              aria-label="bsic tabs example"
            >
              {expenseHeadsPageTabWithId.map((reqType, index) => (
                <Tab 
                key={`sender_${reqType.JobID}`}
                value={reqType.JobID}
                label={tr(reqType.translationKey, reqType.name)} 
                {...waybillFormatPageTabIds(index)} 
                sx={{
                  fontSize: '1rem', height: '40px', minHeight: '40px', fontSize: '12px', fontWeight: '600',
                  display: findObjctByValueFromArrayOfObject(allTabs, reqType.JobID, 'JobID', "IsActive") === 1
                    ? 'block'
                    : 'none',
                }}
                />
              ))}
            </Tabs>
          </Box>
          {expenseHeadsPageTabWithId.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getBookingPageContent(reqType.JobID, tr(reqType.translationKey, reqType.name), selectedTab)}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default ExpenseHead
